module.exports = __webpack_public_path__ + "img/IMG_9919.e5547381.jpg";